import * as React from "react"
import Moment from "react-moment"

const DEFAULT_DATE_FORMAT = "MMMM DD, YYYY"

export const dateDecorator = (date: Date | string, format = DEFAULT_DATE_FORMAT) => {
    return <Moment format={format}>{date}</Moment>
}
